// Storefront APIの検索結果からタグ完全一致する商品を選択する。
// 完全一致する商品がなければ従来通り1件目を返す。
const findExactMatchProduct = (products) => {
  if (!products || products.length <= 1) return products?.[0] || null;

  const selectedItems = document.querySelectorAll('.slider_img_selected');
  const expectedTags = [];

  selectedItems.forEach(item => {
    const key = item.dataset.key;
    const value = item.dataset.value;
    if (key && value) {
      expectedTags.push(`mf${key}_${value}`.toLowerCase());
    }
    const secondaryKey = item.dataset.secondaryitemkey;
    const secondaryValue = item.dataset.secondaryitemvalue;
    if (secondaryKey && secondaryValue) {
      expectedTags.push(`mf${secondaryKey}_${secondaryValue}`.toLowerCase());
    }
  });

  if (expectedTags.length === 0) return products[0];

  const matched = products.find(product => {
    const productTags = product.node.tags.map(t => t.toLowerCase());
    return expectedTags.every(tag => productTags.includes(tag));
  });

  return matched || products[0];
};
